"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKING_LAYER_BG_Z_INDEX = exports.PORTALS_Z_INDEX = exports.MAX_Z_INDEX = void 0;
exports.MAX_Z_INDEX = '100000';
exports.PORTALS_Z_INDEX = '100001';
exports.BLOCKING_LAYER_BG_Z_INDEX = '99990';
//# sourceMappingURL=zIndex.js.map